import React from 'react'
import CategoriesTable from '../../../../shared/DataTable/CategoriesTable'

const Categories = () => {
    return (
        <div className='p-6 lg:w-9/12 mx-auto'>
            <CategoriesTable/>
        </div>
    )
}

export default Categories